<img src="assets/images/no-data-empty-state.svg" alt="No data to display" />
<p class="dds-h5">
  No data to display
</p>
